import React from "react";

const TemperatureIcon = () => {
  return (
    <svg
      width="9"
      height="19"
      viewBox="0 0 9 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.57488 18.875C3.42143 18.875 2.43821 18.3977 1.62523 17.443C0.812251 16.4883 0.405762 15.3337 0.405762 13.9792C0.405762 13.1331 0.575779 12.3444 0.915814 11.6129C1.25585 10.8814 1.72648 10.2812 2.3277 9.8125V2.76388C2.3277 2.03086 2.54584 1.40779 2.98212 0.894661C3.4184 0.381554 3.94816 0.125 4.5714 0.125C5.19466 0.125 5.72558 0.381554 6.16416 0.894661C6.60276 1.40779 6.82206 2.03086 6.82206 2.76388V9.8125C7.42329 10.2812 7.89392 10.8814 8.23395 11.6129C8.57399 12.3444 8.74401 13.1331 8.74401 13.9792C8.74401 15.3337 8.33752 16.4883 7.52454 17.443C6.71156 18.3977 5.72834 18.875 4.57488 18.875ZM3.8061 7.26042H5.34367V2.76388C5.34367 2.50808 5.26999 2.29367 5.12264 2.12065C4.97528 1.94761 4.7927 1.86109 4.57488 1.86109C4.35707 1.86109 4.17449 1.94761 4.02713 2.12065C3.87978 2.29367 3.8061 2.50808 3.8061 2.76388V7.26042Z"
        fill="#56CCF2"
      />
    </svg>
  );
};

export default TemperatureIcon;
